import { CollectionName } from '../../constants';
import { migrateCollections } from '../helpers';
import {
  CurrentMigrationCollectionItem,
  MigratedMigrationCollectionItem,
  MigrationType,
  SingleCollectionMigrationOption,
} from '../types';

const migratePrivateDocumentPropertyAndType = (
  data: CurrentMigrationCollectionItem,
): MigratedMigrationCollectionItem => {
  const { scan, ...rest } = data;

  if (scan !== undefined) {
    return {
      ...rest,
      attachments: [scan],
    };
  }

  return rest;
};

const MIGRATION_OPTIONS: SingleCollectionMigrationOption[] = [
  {
    collectionName: CollectionName.PRIVATE_DOCUMENTS,
    migrateItemFunction: migratePrivateDocumentPropertyAndType,
  },
];

const migrate: MigrationType['migrate'] = (data) => {
  return migrateCollections({
    data,
    migrationOptions: MIGRATION_OPTIONS,
  });
};

export const migration10: MigrationType = {
  migrate,
  version: 11,
};
